// mixin 混入, 是指可以将一个符合 Vue 配置要求的对象, 合并到组件当中
export default {
  methods: {
    dateFormat(date) {
      let newDate = date.split("-");
      let DateTxt = "";
      DateTxt = newDate[1] + "/" + newDate[2] + "/" + newDate[0];

      // newDate = newDate.reverse();
      // console.log(newDate);
      // newDate.forEach((item, index) => {
      //   if (index == newDate.length - 1) {
      //     DateTxt += item;
      //   } else {
      //     DateTxt += item + "/";
      //   }
      // });
      return DateTxt;
    },
    toPrivacyFn(e) {
      this.$router.push({
        path: "policy",
        query: {
          type: e,
        },
      });
    },
    // 价格千分位
    setSumPrice(price, num = 1, locales = "zh-CN", currency = "JPY") {
      if (!price && price != 0) {
        return false;
      }

      if (num < 1) {
        return "-";
      }
      var sum_price = price * num;
      // console.log(sum_price);

      var totalPrice = sum_price.toLocaleString(locales, {});
      // console.log(totalPrice);
      return totalPrice;
    },
  },
};
